import * as GC from '@grapecity/spread-sheets';

export function selectRow(n: number, sheet: GC.Spread.Sheets.Worksheet) {
  // If is implemented, test potential reintroduction of effects
  // Alternative would be to use sheet.setSelection(n, 0, 1, sheet.getColumnCount());
  const rowCount = sheet.getRowCount();
  if (0 < n && n <= rowCount) {
    sheet.clearSelection();
    sheet.addSelection(n - 1, -1, 1, -1);
    sheet.showRow(n - 1, GC.Spread.Sheets.VerticalPosition.center);
  }
}
export function selectColumn(n: number, sheet: GC.Spread.Sheets.Worksheet) {
  // If is implemented, test potential reintroduction of effects
  // Alternative would be to use sheet.setSelection(0, n, 1, sheet.getColumnCount());
  const colCount = sheet.getColumnCount();
  if (0 < n && n <= colCount) {
    sheet.clearSelection();
    sheet.addSelection(-1, n - 1, -1, 1);
  }
}
